// extracted by mini-css-extract-plugin
export var deliveryRow = "_ne-a";
export var fixedHeight = "_ne-4";
export var freightLogo = "_ne-9";
export var fullWidth = "_ne-3";
export var priceColumn = "_ne-5";
export var radioSelected = "_ne-7";
export var radioUnselected = "_ne-6";
export var selectedOption = "_ne-2";
export var selectedOptionContainer = "_ne-1";
export var selection = "_ne-0";
export var tallSkeletonText = "_ne-8";